import Vue from 'vue';
import Vuex from 'vuex';
import players from '@/store/modules/players';
import teams from '@/store/modules/teams';
import filters from '@/store/modules/filters';
import login from '@/store/modules/login';
import bets from '@/store/modules/bets';
import games from '@/store/modules/games';
import next from '@/store/modules/next';
import league from '@/store/modules/league';
import media from '@/store/modules/media';
import profileconfig from '@/store/modules/profileconfig';
import profile from '@/store/modules/profile';
import routes from '@/store/routes';
import general from '@/store/general';
import register from '@/store/modules/register';
import xg from '@/store/modules/xg';
import auth from '@/store/auth';
import terms from '@/store/modules/terms';
import tips from '@/store/modules/tips';
import recover from '@/store/modules/recover';
import alert from '@/store/modules/alert';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowWidth: window.innerWidth,
    isSectionLoading: false,
    displayPremiumMessageV2: false,
    authComponent: null,
    players: [
      {
        player_id: 11556,
        name: 'Luis Alberto Cárdenas López',
        jersey: 22,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/71611/71611.jpg',
        visible: true,
      },
      {
        player_id: 10149,
        name: 'Ángel Zaldívar Caviedes',
        jersey: 9,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/2/79089/79089.jpg',
        visible: true,
      },
      {
        player_id: 16226,
        name: 'Edson Antonio Gutiérrez Moreno',
        jersey: 6,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/88571/88571.jpg',
        visible: true,
      },
      {
        player_id: 27692,
        name: 'Daniel Alexis Parra Durán',
        jersey: 193,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/92536/92536.jpg',
        visible: true,
      },
      {
        player_id: 18010,
        name: 'César Jasib Montes Castro',
        jersey: 3,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/101898/101898.jpg',
        visible: true,
      },
      {
        player_id: 27693,
        name: 'Eric David Cantú Guerrero',
        jersey: 35,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/102634/102634.jpg',
        visible: true,
      },
      {
        player_id: 27034,
        name: 'Jonathan Alexander González Mendoza',
        jersey: 25,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/102681/102681.jpg',
        visible: true,
      },
      {
        player_id: 39038,
        name: 'Johan Felipe Vásquez Ibarra',
        jersey: 5,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/111222/111222.jpg',
        visible: true,
      },
      {
        player_id: 1150,
        name: 'Leonel Jesús Vangioni',
        jersey: 11,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/125997/125997.jpg',
        visible: true,
      },
      {
        player_id: 11760,
        name: 'Maximiliano Eduardo Meza',
        jersey: 32,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/137148/137148.jpg',
        visible: true,
      },
      {
        player_id: 17398,
        name: 'Adam Fernando Bareiro Gamarra',
        jersey: 9,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/137151/137151.jpg',
        visible: true,
      },
      {
        player_id: 15447,
        name: 'Jesús Daniel Gallardo Vasconcelos',
        jersey: 17,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/76953/76953.jpg',
        visible: true,
      },
      {
        player_id: 18870,
        name: 'Edson Alan Reséndez Sánchez',
        jersey: 24,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/82426/82426.jpg',
        visible: false,
      },
      {
        player_id: 2209,
        name: 'Avilés Hurtado Herrera',
        jersey: 18,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/97141/97141.jpg',
        visible: true,
      },
      {
        player_id: 18681,
        name: 'Jaziel Ismael Martínez Huerta',
        jersey: 197,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/98216/98216.jpg',
        visible: false,
      },
      {
        player_id: 27695,
        name: 'Luis Gustavo Sánchez Saucedo',
        jersey: 190,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/109001/109001.jpg',
        visible: false,
      },
      {
        player_id: 4222,
        name: 'Rogelio Gabriel Funes Mori',
        jersey: 7,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/111260/111260.jpg',
        visible: true,
      },
      {
        player_id: 4375,
        name: 'Nicolás Gabriel Sánchez',
        jersey: 4,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/2/123670/123670.jpg',
        visible: false,
      },
      {
        player_id: 344,
        name: 'Osmar Mares Martínez',
        jersey: 20,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/30915/30915.jpg',
        visible: true,
      },
      {
        player_id: 80,
        name: 'Hugo Alfonso González Durán',
        jersey: 1,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/47746/47746.jpg',
        visible: true,
      },
      {
        player_id: 427,
        name: 'Eduardo Herrera Aguirre',
        jersey: 19,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/2/48039/48039.jpg',
        visible: true,
      },
      {
        player_id: 183,
        name: 'Ángel Baltazar Sepúlveda Sánchez',
        jersey: 9,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/65229/65229.jpg',
        visible: true,
      },
      {
        player_id: 10117,
        name: 'Fernando Rubén González Pineda',
        jersey: 25,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/79097/79097.jpg',
        visible: true,
      },
      {
        player_id: 34188,
        name: 'Alexis Francisco Peña López',
        jersey: 28,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/91461/91461.jpg',
        visible: true,
      },
      {
        player_id: 27164,
        name: 'Cristian Yonathan Calderón Del Real',
        jersey: 2,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/93773/93773.jpg',
        visible: true,
      },
      {
        player_id: 2002,
        name: 'Luis Felipe Gallegos Leiva',
        jersey: 6,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/104856/104856.jpg',
        visible: true,
      },
      {
        player_id: 11898,
        name: 'Brayan Antonio Beckeles',
        jersey: 2,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/113815/113815.jpg',
        visible: true,
      },
      {
        player_id: 673,
        name: 'Fernando Nicólas Meza',
        jersey: 5,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/117956/117956.jpg',
        visible: true,
      },
      {
        player_id: 15414,
        name: 'Brian Leonel Fernández',
        jersey: 11,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/132515/132515.jpg',
        visible: true,
      },
      {
        player_id: 342,
        name: 'Yosgart Ernesto Gutiérrez Serna',
        jersey: 25,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/18036/18036.jpg',
        visible: false,
      },
      {
        player_id: 307,
        name: 'José Hibert Alberto Ruíz Vázquez',
        jersey: 17,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/31025/31025.jpg',
        visible: false,
      },
      {
        player_id: 11490,
        name: 'Martín  Barragán  Negrete',
        jersey: 21,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/71688/71688.jpg',
        visible: false,
      },
      {
        player_id: 27121,
        name: 'Luis Donaldo Hernández González',
        jersey: 30,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/70/1/97288/97288.jpg',
        visible: false,
      },
      {
        player_id: 16155,
        name: 'Daniel Álvarez López',
        jersey: 7,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/98245/98245.jpg',
        visible: true,
      },
      {
        player_id: 19240,
        name: 'Facundo Ismael Castro Souto',
        jersey: 8,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/1/132218/132218.jpg',
        visible: true,
      },
      {
        player_id: 12615,
        name: 'Rodrigo Nicolás Contreras',
        jersey: 27,
        photo: 'https://s3.amazonaws.com/lmxwebsite/media/wpagephotos/69/2/138069/138069.jpg',
        visible: true,
      },
    ],
    teams: [
      {
        team_id: 1,
        name: 'Chivas',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/1.png',
      },
      {
        team_id: 2,
        name: 'America',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/2.png',
      },
      {
        team_id: 4,
        name: 'Atlas',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/4.png',
      },
      {
        team_id: 5,
        name: 'Cruz Azul',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/5.png',
      },
      {
        team_id: 7,
        name: 'Rayados de Monterrey',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/7.png',
      },
      {
        team_id: 8,
        name: 'Mazatlan FC',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/8.png',
      },
      {
        team_id: 9,
        name: 'Pachuca FC',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/9.png',
      },
      {
        team_id: 10,
        name: 'Puebla FC',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/10.png',
      },
      {
        team_id: 11,
        name: 'Universidad Nacional',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/11.png',
      },
      {
        team_id: 12,
        name: 'Queretaro',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/12.png',
      },
      {
        team_id: 13,
        name: 'CA San Luis',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/5.png',
      },
      {
        team_id: 14,
        name: 'Santos Laguna',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/14.png',
      },
      {
        team_id: 16,
        name: 'Tigres UANL',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/16.png',
      },
      {
        team_id: 17,
        name: 'Club Tijuana',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/17.png',
      },
      {
        team_id: 18,
        name: 'Toluca',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/18.png',
      },
      {
        team_id: 173,
        name: 'Leon',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/173.png',
      },
      {
        team_id: 194,
        name: 'Lobos BUAP',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/194.png',
      },
      {
        team_id: 205,
        name: 'Necaxa',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/205.png',
      },
      {
        team_id: 469,
        name: 'Veracruz',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/469.png',
      },
      {
        team_id: 3014,
        name: 'FC Juarez',
        logo: 'https://golstatsimages.blob.core.windows.net/teams-80/3014.png',
      },
    ],
    team: 205,
    games: [
      {
        game_id: 53000,
        season_id: 1155,
        home_team: 205,
        visiting_team: 9,
        data: '2019-04-20',
        score: [2, 2],
      },
      {
        game_id: 53010,
        season_id: 1155,
        home_team: 7,
        visiting_team: 205,
        data: '2019-04-27',
        score: [2, 2],
      },
    ],
  },
  getters: {
    showAuthComponent(state) {
      // console.log('EL VALOR CAMBIO Y SE ENVIA:');
      return Boolean(state.authComponent);
    },
    displayPremiumMessageV2: state => state.displayPremiumMessageV2,
    availableGames: state => {
      return state.games.map(g => {
        let home_team = state.teams.find(t => t.team_id == g.home_team);
        let visiting_team = state.teams.find(t => t.team_id == g.visiting_team);

        return {
          gameId: g.game_id,
          title: `${home_team.name} VS ${visiting_team.name}`,
          homeTeamId: g.home_team,
          homeTeamName: home_team.name,
          homeTeamLogo: home_team.logo,
          visitingTeamId: g.visiting_team,
          visitingTeamName: visiting_team.name,
          visitingTeamLogo: visiting_team.logo,
        };
      });
    },
  },
  mutations: {
    SET_AUTH_COMPONENT(state, component) {
      // console.log('EL SE SETEA:');
      // console.log(component);
      state.authComponent = component;
    },
    SET_PREMIUM_MESSAGE_V2(state, value) {
      state.displayPremiumMessageV2 = value;
    },
    setWindowWidth(state) {
      state.windowWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    },
    setIsSectionLoading(state, isSectionLoading) {
      state.isSectionLoading = isSectionLoading;
    },
  },
  modules: {
    general,
    routes,
    ...players,
    ...teams,
    ...filters,
    ...login,
    ...games,
    ...next,
    ...league,
    ...media,
    ...profileconfig,
    ...profile,
    ...register,
    ...bets,
    ...auth,
    ...xg,
    ...terms,
    ...alert,
    ...recover,
    ...tips,
  },
});
